import { render, staticRenderFns } from "./LoginCard.vue?vue&type=template&id=22b78315"
import script from "./LoginCard.vue?vue&type=script&lang=js"
export * from "./LoginCard.vue?vue&type=script&lang=js"
import style0 from "./LoginCard.vue?vue&type=style&index=0&id=22b78315&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports